const t = "styles-module__inputLabel___fdZFC", e = "styles-module__desktop___OtuBs", s = "styles-module__mobile___1Nbp2", _ = "styles-module__textWithEmail___J-Bot", l = {
  inputLabel: t,
  desktop: e,
  mobile: s,
  textWithEmail: _
};
export {
  l as default,
  e as desktop,
  t as inputLabel,
  s as mobile,
  _ as textWithEmail
};
